import './index.css';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';

import darkIcon from '../favicon_apple.png';
import lightIcon from '../favicon_apple_white.png';
import { capacitorService } from './application/CapacitorService';
import { GlobalContextProvider } from './context';
import { useDisableAndroidBackButton } from './hooks/useBackButton';
import { Drivers } from './pages/Drivers';
import configuration from './services/configuration';
import { routalLocalNotifications } from './services/localNotifications';

export const App = () => {
  useDisableAndroidBackButton();
  const [faviconHref, setFaviconHref] = useState(darkIcon);

  useEffect(() => {
    routalLocalNotifications.initLocalNotifications();

    if (capacitorService.isIOS()) {
      document.body.style.backgroundColor = RoutalPalette.primary80;
    }
  }, []);

  useEffect(() => {
    // Get current color scheme.
    const matcher = window.matchMedia(`(prefers-color-scheme: dark)`);
    // Set favicon initially.
    setFaviconHref(getFaviconPath(matcher.matches));
    // Change favicon if the color scheme changes.
    matcher.onchange = () => setFaviconHref(getFaviconPath(matcher.matches));
  }, [faviconHref]);

  /**
   * Returns the path for a favicon based on the given color scheme.
   *
   * @param {boolean} isDarkMode If currently in dark mode
   */
  const getFaviconPath = (isDarkMode = false) => {
    if (!isDarkMode) return darkIcon;
    else return lightIcon;
  };

  const getEnvironmentChar = () => {
    switch (configuration.ENVIRONMENT) {
      case `DEVELOPMENT`:
        return `[D] `;
      case `STAGING`:
        return `[S] `;
      case `PRODUCTION`:
      default:
        return ``;
    }
  };

  // Create a client
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: `offlineFirst`,
      },
      mutations: {
        networkMode: `offlineFirst`,
      },
    },
  });

  console.info(`[FD] Drivers analytics wip`);

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Helmet title={`${getEnvironmentChar()}Drivers`}>
          <link rel="icon" href={faviconHref} />
        </Helmet>
        <GlobalContextProvider>
          <Drivers />
        </GlobalContextProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </BrowserRouter>
  );
};
